import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"position":"fixed","margin":"1px","padding":"0px","left":"1px","top":"1px","z-index":"10"}
}
const _hoisted_2 = {
  class: "flex-container",
  style: {"z-index":"0"}
}
const _hoisted_3 = {
  key: 0,
  class: "flex-fit"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  style: {"background-color":"#C0C0C0"}
}
const _hoisted_6 = { style: {"padding":"0 3px 0 3px"} }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { style: {"padding":"0 3px 0 3px"} }
const _hoisted_9 = {
  key: 0,
  style: {"text-align":"left"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "aktualnihodnoty" }, "Aktuální hodnoty", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "grafhodnoty" }, "Graf", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "mojediv" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Signál"),
    /*#__PURE__*/_createElementVNode("th", null, "Hodnota"),
    /*#__PURE__*/_createElementVNode("th", null, "[ ]")
  ])
], -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { style: {"max-height":"100px","background-color":"white"} }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex-do-konce" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CoralGraph = _resolveComponent("CoralGraph")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", null, _toDisplayString(_ctx.msg), 1),
    (_ctx.bVidetBtnZpet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.btnZpet && _ctx.btnZpet(...args))),
            style: {"padding":"3px 10px"}
          }, "Zpět")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.bVidetStanice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nacteneStanice, (stanice, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: _withModifiers(($event: any) => (_ctx.vyberStanice(stanice)), ["stop"]),
                  tabindex: "0",
                  style: {"padding":"0px"}
                }, [
                  (stanice == _ctx.vybranaStanice)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(stanice.jmeno), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(stanice.jmeno), 1)
                      ]))
                ], 8, _hoisted_4))
              }), 128))
            ]),
            (_ctx.bMobil)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "aktualnihodnoty",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bMobilPozadavekAktualni) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.bMobilPozadavekAktualni]
                  ]),
                  _hoisted_10,
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "grafhodnoty",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bMobilPozadavekGraf) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.bMobilPozadavekGraf]
                  ]),
                  _hoisted_12,
                  _hoisted_13
                ]))
              : _createCommentVNode("", true),
            (!_ctx.bMobil && _ctx.vybranaStanice != null)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  style: {"margin":"20px"},
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.btnPouzeGraf && _ctx.btnPouzeGraf(...args)))
                }, " Graf podrobně "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_14, " ← vyberte stanici ", 512), [
        [_vShow, _ctx.vybranaStanice == null]
      ]),
      (_ctx.bVidetAktualni && _ctx.vybranaStanice != null)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "flex-fit tableFixHead",
            style: _normalizeStyle(_ctx.computedStyle)
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.vybranaStanice.jmeno), 1),
            _createElementVNode("table", null, [
              _hoisted_15,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrAktualniHodnoty, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.jmeno
                  }, [
                    _createElementVNode("td", null, _toDisplayString(row.jmeno), 1),
                    (Array.isArray(row.hodnota))
                      ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                          _createElementVNode("ul", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.hodnota, (item) => {
                              return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(row.hodnota), 1)),
                    _createElementVNode("td", null, _toDisplayString(row.jednotka), 1)
                  ]))
                }), 128))
              ])
            ])
          ], 4))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_19, [
        _createVNode(_component_CoralGraph, { propVybranaStanice: _ctx.vybranaStanice }, null, 8, ["propVybranaStanice"])
      ], 512), [
        [_vShow, _ctx.bVidetGraf && _ctx.vybranaStanice != null]
      ])
    ])
  ], 64))
}